import { useState, useCallback, TouchEvent, WheelEvent } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline } from "@mui/material";
import { createAppTheme } from "./theme";
import { useThemeContext } from './ThemeContext';
import Home from "./pages/home/Home";
import Introduction from "./pages/introduction/Introduction";
import About from "./pages/about/About";
import Skills from "./pages/skills/Skills";
import WorkExp from "./pages/workExp/WorkExp";
import PortfolioProject from "./pages/portfolioProject/PortfolioProject";
import Project1 from "./pages/project1/Project1";
import Project2 from "./pages/project2/Project2";
import Last from "./pages/last/Last";

const sections = [<Home />, <Introduction />, <About />, <Skills />, <WorkExp />, <PortfolioProject />, <Project1 />, <Project2 />, <Last />];

const App = () => {
  const [index, setIndex] = useState(0);
  const [isScrolling, setIsScrolling] = useState(false);
  const [direction, setDirection] = useState<1 | -1>(1)
  const [touchStart, setTouchStart] = useState<number>(0);

  const handleScroll = useCallback((event: WheelEvent) => {
    if (isScrolling) return; // Если уже скроллим, игнорируем новый вызов

    setIsScrolling(true); // Блокируем повторный вызов
    setTimeout(() => setIsScrolling(false), 700); // Разблокировка через 700 мс

    if (event.deltaY > 0) {
      setDirection(1)
      setIndex((prev) => Math.min(prev + 1, sections.length - 1));
    } else {
      setDirection(-1)
      setIndex((prev) => Math.max(prev - 1, 0));
    }
  }, [isScrolling]);

  const handleTouchStart = (event: TouchEvent<HTMLDivElement>) => {
    setTouchStart(event.touches[0].clientY);
  };

  const handleTouchEnd = (event: TouchEvent<HTMLDivElement>) => {
    if (isScrolling) return;

    const touchEnd = event.changedTouches[0].clientY;
    const deltaY = touchStart - touchEnd;

    if (Math.abs(deltaY) > 50) {
      setIsScrolling(true);
      setTimeout(() => setIsScrolling(false), 700);

      if (deltaY > 0) {
        setDirection(1);
        setIndex((prev) => Math.min(prev + 1, sections.length - 1));
      } else {
        setDirection(-1);
        setIndex((prev) => Math.max(prev - 1, 0));
      }
    }
  };

  // Получаем текущий режим темы из контекста
  const { mode } = useThemeContext();

  // Обновляем тему в зависимости от состояния mode
  const theme = createAppTheme(mode);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <div
        // className="w-screen h-screen flex items-center justify-center overflow-hidden bg-gray-900 text-white"
        onWheel={handleScroll}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <AnimatePresence mode="wait">
          <motion.div
            key={index}
            initial={{ opacity: 0, y: direction * 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: direction * -50 }}
            transition={{ duration: 0.5 }}
          >
            {sections[index]}
          </motion.div>
        </AnimatePresence>
      </div>
    </MuiThemeProvider>
  );
}

export default App;